/* Wynden Home — cart drawer behaviour.
   Подключается один раз в layout/theme.liquid:
   <script src="{{ 'wh-cart.js' | asset_url }}" defer="defer"></script> */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     ДОБОРЫ. Handle товаров, которые нельзя купить без основного товара.
     Если в корзине не осталось ни одного НЕ-добора — доборы удаляются.
     Чтобы добавить или убрать товар из правила — правь только этот список.
     ------------------------------------------------------------------ */
  var ADDON_HANDLES = [
    'acacia-wood-utensil-holder',
    'acacia-wood-spoon-rest',
    'personalized-engraving',
    // Части бандла The Complete Set. Отдельно не продаются, но их карточки
    // видны в поиске — оттуда набор можно положить в корзину кнопкой «Add».
    'acacia-wood-kitchen-utensil-set'
  ];
  /* ---- тексты на языке страницы ----
     Секция wh-cart-drawer кладёт на страницу <script type="application/json" id="wh-i18n-cart">
     со строками из locales/*.json. EN — запасной вариант. */
  var EN = {"addon_notice": "Add-ons ship with a set, so they were removed too.", "addon_label": "Add-on \u2014 ships with your set", "max_notice": "Up to {n} sets per order. For more, please place a separate order.", "eng_label": "Engraving \u2014 applied to the set in your bag", "eng_notice": "Engraving was removed \u2014 no set in your bag carries a personalized text.", "ask_text": "Your add-ons ship with this set. Removing it removes them too.", "ask_yes": "Remove both", "ask_no": "Keep the set", "ship_msg": "We could not add that to your bag. We ship to the United States, Canada, Australia, New Zealand, Mexico and the United Arab Emirates. If you are in one of those and still see this, please email support@wyndenhome.com."};
  var I18N = null;
  var decBox = document.createElement('textarea');
  function T(k, vars) {
    if (!I18N) {
      try { I18N = JSON.parse((document.getElementById('wh-i18n-cart') || {}).textContent || 'null'); } catch (e) { I18N = null; }
    }
    var v = I18N && I18N[k];
    if (v == null || v === '' || /^translation missing/i.test(String(v))) v = EN[k] != null ? EN[k] : k;
    decBox.innerHTML = String(v);
    v = decBox.value;
    if (vars) Object.keys(vars).forEach(function (n) { v = v.split('{' + n + '}').join(vars[n]); });
    return v;
  }


  /* ------------------------------------------------------------------
     ГРАВИРОВКА. Товар personalized-engraving имеет два варианта:
       платный ($20)  — когда в корзине один набор;
       бесплатный ($0) — когда наборов два и больше.
     Скрипт сам держит в корзине ровно одну строку нужного варианта.
     Если бесплатного варианта в товаре нет — работает только платный.
     ------------------------------------------------------------------ */
  var ENG_HANDLE = 'personalized-engraving';
  var SET_HANDLES = ['the-complete-set-12-pieces']; // наборы, которые считаются для бесплатной гравировки
  var FREE_FROM = 2;                                  // с какого количества наборов гравировка бесплатна

  /* ------------------------------------------------------------------
     ПОТОЛОК НАБОРОВ. В одном заказе — не больше MAX_SETS наборов
     (цены на витрине и скидки в админке рассчитаны на 1, 2 и 3).
     Если через любую кнопку набралось больше, корзина сама убирает
     лишние, начиная с последних добавленных, и показывает подпись.
     ------------------------------------------------------------------ */
  var MAX_SETS = 3;

  /* Подарок из окна «бесплатная гравировка» (assets/wh-exit-offer.js).
     Пока стоит этот cookie, гравировка бесплатна и на ОДИН набор.
     Без этой проверки корзина честно возвращала бы платный вариант
     обратно и списала бы $20 за то, что мы пообещали бесплатно. */
  function giftOn() {
    try { return /(?:^|;\s*)wh_exit_offer_claimed=1(?:;|$)/.test(document.cookie); }
    catch (e) { return false; }
  }
  var ENG_PROP   = 'Engraving — Line 1';
  function labelFor(handle) { return handle === ENG_HANDLE ? T('eng_label') : T('addon_label'); }

  /* ------------------------------------------------------------------
     ЗАЛИПШАЯ КОРЗИНА. Если корзине досталась страна, куда магазин не возит
     (человек ввёл такой адрес на чекауте или сидит под VPN), Shopify стирает
     корзину и на любое добавление отвечает «already sold out» — до конца
     визита. Лечение: удалить cookie корзины и повторить добавление один раз.
     Если и это не помогло — честно сказать, куда мы возим.
     ------------------------------------------------------------------ */
  function resetCartCookie() {
    try {
      document.cookie = 'cart=; Max-Age=0; path=/';
      document.cookie = 'cart_sig=; Max-Age=0; path=/';
    } catch (e) {}
  }
  window.whResetCart = resetCartCookie;

  var SECTION_ID = 'wh-cart-drawer';
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };
  var pendingNotice = null;
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* Свои запросы идут через nativeFetch — их не видит перехватчик ниже. */
  var nativeFetch = window.fetch.bind(window);

  function drawerHost() {
    return document.getElementById('shopify-section-' + SECTION_ID);
  }

  function drawer() {
    var host = drawerHost();
    return host ? host.querySelector('[data-wh-drawer]') : null;
  }

  function setCount(count) {
    document.querySelectorAll('[data-wh-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = false;
    });
  }

  function getCartRaw() {
    return nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Каждый раз, когда скрипт читает корзину, через короткую паузу обновляем заметку
     с гравировкой (см. syncEngravingNote ниже). */
  function getCart() {
    return getCartRaw().then(function (cart) { scheduleNote(); return cart; });
  }

  function postCart(path, body) {
    return nativeFetch(root() + path, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) });
  }

  /* ---------- гравировка в заметку к заказу ----------
     Свойства гравировки сидят внутри бандла: в списке заказов их не видно, а Teemdrop их
     не передаёт. Поэтому, пока в корзине есть набор с гравировкой, держим в cart.note
     блок с текстом, шрифтом и ссылками на макет — он попадает в «Заметку» заказа.
     Блок стоит между маркерами: если покупатель когда-нибудь сам что-то напишет в заметку,
     его текст останется. Запросы идут через nativeFetch, чтобы не будить afterExternalChange. */
  var NOTE_START = '=== ENGRAVING ===';
  var NOTE_END = '=== END ENGRAVING ===';
  var noteTimer = 0;

  function buildEngravingNote(cart) {
    var blocks = [];
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      if (!p[ENG_PROP] && !p['Engraving']) return;
      var rows = ['Set ' + (blocks.length + 1) + ' (qty ' + item.quantity + '). Engrave on all 10 utensils.'];
      if (p['Engraving']) rows.push('Engraving: ' + p['Engraving']);
      if (p['Engraving — Line 1']) rows.push('Line 1: ' + p['Engraving — Line 1']);
      if (p['Engraving — Line 2']) rows.push('Line 2: ' + p['Engraving — Line 2']);
      var font = p['_Engraving — Font family'] || p['Engraving — Font'];
      if (font) rows.push('Font: ' + font);
      if (p['_Engraving — Line 1 size']) rows.push('Size: ' + p['_Engraving — Line 1 size']);
      if (p['Engraving — Alignment']) rows.push('Alignment: ' + p['Engraving — Alignment']);
      if (p['_Engraving artwork']) rows.push('Artwork (PNG): ' + p['_Engraving artwork']);
      if (p['Engraving preview']) rows.push('Preview (JPG): ' + p['Engraving preview']);
      blocks.push(rows.join('\n'));
    });
    return blocks.length ? NOTE_START + '\n' + blocks.join('\n\n') + '\n' + NOTE_END : '';
  }

  function syncEngravingNote() {
    return getCartRaw().then(function (cart) {
      var current = cart.note || '';
      var a = current.indexOf(NOTE_START);
      var b = current.indexOf(NOTE_END);
      var rest = (a !== -1 && b !== -1) ? (current.slice(0, a) + current.slice(b + NOTE_END.length)) : current;
      rest = rest.replace(/^\s+|\s+$/g, '');
      var next = [rest, buildEngravingNote(cart)].filter(Boolean).join('\n\n');
      if (next === current) return null;
      return postCart('cart/update.js', { note: next });
    }).catch(function () { return null; });
  }

  function scheduleNote() {
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(syncEngravingNote, 400);
  }

  function isAddon(item) {
    return ADDON_HANDLES.indexOf(item.handle) !== -1;
  }

  /* ---------- варианты гравировки: платный и бесплатный ---------- */
  var engVariants = null;
  function loadEngVariants() {
    if (engVariants) return Promise.resolve(engVariants);
    return nativeFetch(root() + 'products/' + ENG_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var paid = 0, free = 0, paidPrice = -1;
        (p.variants || []).forEach(function (v) {
          if (v.price === 0) { if (!free) free = v.id; }
          else if (v.price > paidPrice) { paidPrice = v.price; paid = v.id; }
        });
        engVariants = { paid: paid, free: free };
        return engVariants;
      })
      .catch(function () { return { paid: 0, free: 0 }; });
  }

  /* Возвращает Promise<true>, если корзину пришлось поправить. */
  function enforceAddons() {
    if (!ADDON_HANDLES.length) return Promise.resolve(false);

    return getCart().then(function (cart) {
      if (!cart.items || !cart.items.length) return false;

      // Больше MAX_SETS наборов — убираем лишние. Shopify ставит новые строки
      // первыми, поэтому снимаем с начала списка: уходит то, что добавили последним.
      var setTotal = cart.items.reduce(function (a, it) {
        return SET_HANDLES.indexOf(it.handle) !== -1 ? a + it.quantity : a;
      }, 0);
      if (setTotal > MAX_SETS) {
        var extra = setTotal - MAX_SETS;
        var lines = cart.items.map(function (it) {
          if (extra > 0 && SET_HANDLES.indexOf(it.handle) !== -1) {
            var cut = Math.min(extra, it.quantity);
            extra -= cut;
            return it.quantity - cut;
          }
          return it.quantity;
        });
        return postCart('cart/update.js', { updates: lines })
          .then(function () {
            pendingNotice = T('max_notice', { n: MAX_SETS });
            return enforceAddons().then(function () { return true; });
          })
          .catch(function () { return false; });
      }

      var hasMain = cart.items.some(function (item) { return !isAddon(item); });
      if (hasMain) {
        var engLines = cart.items.filter(function (item) { return item.handle === ENG_HANDLE; });
        if (!engLines.length) return false;

        var engravedSet = cart.items.some(function (item) {
          return item.handle !== ENG_HANDLE && item.properties && item.properties[ENG_PROP];
        });

        // Ни один набор не несёт текст — гравировке нечего делать в корзине.
        if (!engravedSet) {
          var drop = {};
          engLines.forEach(function (item) { drop[item.variant_id] = 0; });
          return postCart('cart/update.js', { updates: drop })
            .then(function () { if (pendingNotice !== T('max_notice', { n: MAX_SETS })) pendingNotice = T('eng_notice'); return true; })
            .catch(function () { return false; });
        }

        // Есть гравированный набор — держим ровно одну строку нужного варианта.
        return loadEngVariants().then(function (v) {
          var setQty = cart.items.reduce(function (a, it) {
            return SET_HANDLES.indexOf(it.handle) !== -1 ? a + it.quantity : a;
          }, 0);
          var freeNow = (setQty >= FREE_FROM || giftOn());
          var want = (freeNow && v.free) ? v.free : (v.paid || engLines[0].variant_id);

          var upd = {}, changed = false, wantQty = 0;
          engLines.forEach(function (item) {
            if (item.variant_id === want) wantQty += item.quantity;
            else { upd[item.variant_id] = 0; changed = true; }
          });
          if (wantQty !== 1) { upd[want] = 1; changed = true; }
          if (!changed) return false;

          return postCart('cart/update.js', { updates: upd })
            .then(function () { return true; })
            .catch(function () { return false; });
        });
      }

      // В корзине остались только доборы — убираем их все.
      var updates = {};
      cart.items.forEach(function (item) { updates[item.variant_id] = 0; });

      return postCart('cart/update.js', { updates: updates })
        .then(function () {
          pendingNotice = T('addon_notice');
          return true;
        })
        .catch(function () { return false; });
    }).catch(function () { return false; });
  }

  function showNotice() {
    if (!pendingNotice) return;
    var el = drawer();
    if (!el) return;
    var panel = el.querySelector('.wh-cd__panel');
    var head = panel && panel.querySelector('.wh-cd__head');
    if (!panel || !head) return;

    var note = document.createElement('div');
    note.className = 'wh-cd__strip';
    note.setAttribute('data-wh-notice', '');
    note.textContent = pendingNotice;
    panel.insertBefore(note, head.nextSibling);
    pendingNotice = null;
  }

  /* ---------- стили для подписи добора и подтверждения ---------- */
  function injectStyles() {
    if (document.getElementById('wh-cart-inline-styles')) return;
    var css = [
      '.wh.wh-cd .wh-cd__item--addon{background:var(--wh-bg-2);position:relative}',
      '.wh.wh-cd .wh-cd__item--addon::before{content:"";position:absolute;left:0;top:0;bottom:0;width:2px;background:var(--wh-btn)}',
      '.wh.wh-cd .wh-cd__addon-tag{margin-top:5px;font-size:10px;letter-spacing:.06em;color:var(--wh-btn);font-weight:400}',
      '.wh.wh-cd .wh-cd__ask{padding:16px 26px 18px;background:var(--wh-band);border-bottom:1px solid var(--wh-line-soft)}',
      '.wh.wh-cd .wh-cd__ask-t{font-size:12px;font-weight:300;line-height:1.5;color:var(--wh-text);margin-bottom:12px}',
      '.wh.wh-cd .wh-cd__ask-b{display:flex;gap:8px}',
      '.wh.wh-cd .wh-cd__ask-b button{font-family:var(--wh-sans);font-size:9.5px;letter-spacing:.13em;text-transform:uppercase;padding:9px 14px;cursor:pointer;border:1px solid rgba(46,42,36,.3);background:none;color:var(--wh-text)}',
      '.wh.wh-cd .wh-cd__ask-b button.is-primary{background:var(--wh-btn);border-color:var(--wh-btn);color:var(--wh-btn-text)}',
      /* Пока галочка про гравировку не отмечена, она мягко пульсирует — иначе человек
         жмёт Checkout и не понимает, почему ничего не происходит. */
      '.wh.wh-cd .wh-cd__confirm.is-wait{animation:wh-pulse 1.8s ease-in-out infinite}',
      '.wh.wh-cd .wh-cd__confirm.is-wait .wh-cd__confirm-box{border-color:var(--wh-btn)}',
      '@keyframes wh-pulse{0%,100%{box-shadow:0 0 0 0 rgba(78,86,71,0)}50%{box-shadow:0 0 0 4px rgba(78,86,71,.22)}}',
      '.wh.wh-cd .wh-cd__confirm.is-missing{animation:wh-shake .45s ease-in-out 2}',
      '@keyframes wh-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}',
      '@media (prefers-reduced-motion: reduce){.wh.wh-cd .wh-cd__confirm.is-wait,.wh.wh-cd .wh-cd__confirm.is-missing{animation:none}.wh.wh-cd .wh-cd__confirm.is-wait{box-shadow:0 0 0 3px rgba(78,86,71,.2)}}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'wh-cart-inline-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* Кнопка Checkout остаётся живой даже без галочки: по клику подсвечиваем
     галочку и подводим к ней, вместо серой кнопки, которая молчит. */
  function syncConfirm() {
    var el = drawer();
    if (!el) return;
    var cb = el.querySelector('[data-wh-eng-ok]');
    var btn = el.querySelector('.wh-cd__checkout');
    if (btn) btn.disabled = false;
    var wrap = cb ? cb.closest('.wh-cd__confirm') : null;
    if (wrap) wrap.classList.toggle('is-wait', !cb.checked);
  }

  function handleFromHref(href) {
    if (!href) return '';
    var parts = href.split('/products/');
    if (parts.length < 2) return '';
    return parts[1].split('?')[0].split('#')[0].replace(/\/$/, '');
  }

  /* Помечает строки доборов подписью и полосой слева. */
  function markAddons() {
    var el = drawer();
    if (!el) return;
    el.querySelectorAll('.wh-cd__item').forEach(function (item) {
      var link = item.querySelector('.wh-cd__name');
      if (!link) return;
      if (ADDON_HANDLES.indexOf(handleFromHref(link.getAttribute('href'))) === -1) return;

      item.classList.add('wh-cd__item--addon');
      if (item.querySelector('.wh-cd__addon-tag')) return;
      var tag = document.createElement('div');
      tag.className = 'wh-cd__addon-tag';
      tag.textContent = labelFor(handleFromHref(link.getAttribute('href')));
      link.parentNode.appendChild(tag);
    });
  }

  /* Спрашивает перед удалением последнего основного товара. */
  function askConfirm(proceed) {
    var el = drawer();
    var body = el && el.querySelector('.wh-cd__body');
    if (!body) return proceed();

    var existing = body.querySelector('.wh-cd__ask');
    if (existing) existing.remove();

    var box = document.createElement('div');
    box.className = 'wh-cd__ask';
    box.innerHTML = '<div class="wh-cd__ask-t"></div><div class="wh-cd__ask-b"></div>';
    box.querySelector('.wh-cd__ask-t').textContent = T('ask_text');

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'is-primary';
    yes.textContent = T('ask_yes');
    yes.addEventListener('click', function () { box.remove(); proceed(); });

    var no = document.createElement('button');
    no.type = 'button';
    no.textContent = T('ask_no');
    no.addEventListener('click', function () { box.remove(); });

    var row = box.querySelector('.wh-cd__ask-b');
    row.appendChild(yes);
    row.appendChild(no);

    body.insertBefore(box, body.firstChild);
    body.scrollTop = 0;
  }

  /* Нужно ли спросить: убираем последний основной товар, а доборы остаются. */
  function guardLineChange(line, qty, proceed) {
    if (Number(qty) > 0) return proceed();

    getCart().then(function (cart) {
      var index = Number(line) - 1;
      var item = cart.items && cart.items[index];
      if (!item || isAddon(item)) return proceed();

      var otherMain = cart.items.filter(function (it, i) { return i !== index && !isAddon(it); });
      var addons = cart.items.filter(isAddon);
      if (otherMain.length || !addons.length) return proceed();

      askConfirm(proceed);
    }).catch(proceed);
  }

  function open() {
    var el = drawer();
    if (!el) return;
    el.hidden = false;
    void el.offsetWidth; // форсируем reflow, чтобы сработал transition
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = el.querySelector('.wh-cd__close');
    if (closeBtn) closeBtn.focus();
    scheduleNote();
  }

  function close() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      var current = drawer();
      if (current && !current.classList.contains('is-open')) current.hidden = true;
    }, 320);
  }

  /* Вставляет готовую разметку секции дровера. Её можно получить двумя путями:
     отдельным запросом (renderDrawer) или сразу в ответе cart/add.js с параметром
     sections — второй путь экономит два обращения к серверу. */
  function applySectionHtml(html) {
    var host = drawerHost();
    if (!host || !html) return false;
    var wasOpen = drawer() && drawer().classList.contains('is-open');
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#shopify-section-' + SECTION_ID);
    host.innerHTML = fresh ? fresh.innerHTML : html;
    if (wasOpen) {
      var el = drawer();
      if (el) { el.hidden = false; el.classList.add('is-open'); }
    }
    showNotice();
    markAddons();
    syncConfirm();
    return true;
  }

  /* Для wh-engraving.js: показать корзину сразу из ответа cart/add.js. */
  window.whApplyCartSections = function (sections) {
    var html = sections && sections[SECTION_ID];
    if (!applySectionHtml(html)) return false;
    open();
    enforceAddons().then(function (changed) {
      if (changed) return refresh();
      return getCart().then(function (cart) {
        setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('wh:cart:updated', { detail: cart }));
      });
    });
    return true;
  };

  function renderDrawer() {
    var host = drawerHost();
    if (!host) return Promise.resolve();
    // Не используем /?sections=…: Shopify отдаёт главную из страничного кеша,
    // и дровер показывал устаревшую корзину. Пустой update.js с параметром
    // sections всегда возвращает секцию, отрисованную по актуальной корзине.
    return postCart('cart/update.js', { updates: {}, sections: SECTION_ID })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        applySectionHtml(data && data.sections ? data.sections[SECTION_ID] : null);
      });
  }

  /* Правило доборов проверяется перед каждой перерисовкой. */
  function refresh() {
    return enforceAddons()
      .then(renderDrawer)
      .then(function () { return getCart(); })
      .then(function (cart) {
        setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('wh:cart:updated', { detail: cart }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.Shopify && window.Shopify.PubSub && window.Shopify.PubSub.publish) {
          window.Shopify.PubSub.publish('cart:updated', { cart: cart });
        }
        return cart;
      })
      .catch(function () {});
  }

  function addToCart(body, button) {
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }
    function once() {
      return postCart('cart/add.js', body).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, json: j }; });
      });
    }
    return once()
      .then(function (res) {
        if (res.ok) return res.json;
        resetCartCookie();              // корзина залипла — сбрасываем и пробуем ещё раз
        return once().then(function (res2) {
          if (res2.ok) return res2.json;
          throw new Error('add failed');
        });
      })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function () { window.alert(T('ship_msg')); })
      .then(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        }
      });
  }

  function changeLine(line, quantity) {
    return postCart('cart/change.js', { line: Number(line), quantity: Number(quantity) })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function () {});
  }

  /* ---------- чужие изменения корзины ----------
     Тема (страница /cart, её own +/−) меняет корзину своими запросами.
     Перехватываем fetch: после любого чужого cart/add|change|update
     проверяем правило доборов и вариант гравировки. */
  var externalTimer = null;
  function afterExternalChange() {
    window.clearTimeout(externalTimer);
    externalTimer = window.setTimeout(function () {
      enforceAddons().then(function (changed) {
        var onCartPage = /\/cart\/?$/.test(window.location.pathname);
        if (changed && onCartPage) { window.location.reload(); return; }
        if (changed) return refresh();
        return getCart().then(function (cart) { setCount(cart.item_count); });
      });
    }, 150);
  }
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
        p.then(function () { afterExternalChange(); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  /* ---------- add-to-cart forms ----------
     Слушаем на window в фазе погружения (capture): window идёт в цепочке
     событий раньше document, а Horizon вешает свой capture-обработчик
     именно на document. Иначе тема добавит товар вторым запросом. */
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-wh-skip')) return;

    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return; // пусть тема обработает сама

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var qtyField = form.querySelector('[name="quantity"]');
    var payload = {
      items: [{
        id: Number(idField.value),
        quantity: Number(qtyField && qtyField.value ? qtyField.value : 1)
      }]
    };

    var sellingPlan = form.querySelector('[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value) payload.items[0].selling_plan = Number(sellingPlan.value);

    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.type === 'checkbox' && !field.checked) return;
      var key = field.name.replace('properties[', '').replace(']', '');
      properties[key] = field.value;
    });
    if (Object.keys(properties).length) payload.items[0].properties = properties;

    addToCart(payload, form.querySelector('[type="submit"]'));
  }, true);

  /* ---------- подтверждение гравировки перед оплатой ----------
     Если в корзине есть гравированный набор, дровер рисует галочку
     [data-wh-eng-ok] и кнопку Checkout с атрибутом disabled. */
  document.addEventListener('change', function (event) {
    var cb = event.target.closest && event.target.closest('[data-wh-eng-ok], [data-wh-pg-eng-ok]');
    if (!cb) return;
    // Галочку (в шторке или на странице /cart) ставят прямо перед оплатой — в этот момент заметка с гравировкой должна быть в корзине.
    syncEngravingNote();
    var el = drawer();
    var wrap = cb.closest('.wh-cd__confirm');
    if (wrap) { wrap.classList.remove('is-missing'); wrap.classList.toggle('is-wait', !cb.checked); }
  });
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('[data-wh-drawer]')) return;
    var cb = form.closest('[data-wh-drawer]').querySelector('[data-wh-eng-ok]');
    if (!cb || cb.checked) return;
    event.preventDefault();
    event.stopPropagation();
    var wrap = cb.closest('.wh-cd__confirm');
    if (wrap) {
      wrap.classList.add('is-missing');
      try { wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
      window.setTimeout(function () { wrap.classList.remove('is-missing'); }, 1200);
    }
  }, true);

  /* ---------- клик по корзине темы ----------
     Тоже capture: перехватываем ссылку на /cart в шапке Horizon
     и открываем наш дровер вместо перехода на страницу корзины. */
  window.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (event.target.closest('[data-wh-drawer]')) return;
    if (event.target.closest('[data-wh-cart-open]')) return;

    var link = event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (!/\/cart\/?($|\?)/.test(href)) return;
    if (link.hasAttribute('data-wh-skip')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || link.target === '_blank') return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    refresh().then(open);
  }, true);

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-wh-cart-open]');
    if (openBtn) {
      event.preventDefault();
      refresh().then(open);
      return;
    }

    var closeBtn = event.target.closest('[data-wh-drawer-close]');
    if (closeBtn) {
      event.preventDefault();
      close();
      return;
    }

    var lineBtn = event.target.closest('[data-wh-line-change]');
    if (lineBtn) {
      event.preventDefault();
      var lineIndex = lineBtn.getAttribute('data-wh-line-change');
      var lineQty = lineBtn.getAttribute('data-wh-line-qty');
      guardLineChange(lineIndex, lineQty, function () {
        lineBtn.disabled = true;
        changeLine(lineIndex, lineQty);
      });
      return;
    }

    var quickAdd = event.target.closest('[data-wh-quick-add]');
    if (quickAdd && quickAdd.tagName === 'BUTTON') {
      event.preventDefault();
      addToCart({ items: [{ id: Number(quickAdd.getAttribute('data-wh-quick-add')), quantity: 1 }] }, quickAdd);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var el = drawer();
    if (el && el.classList.contains('is-open')) close();
  });

  /* ---------- на загрузке страницы ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    markAddons();
    syncConfirm();
    enforceAddons().then(function (changed) {
      // На странице /cart содержимое отрисовано сервером — нужен перезаход.
      if (changed && /\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
        return;
      }
      return getCart().then(function (cart) { setCount(cart.item_count); });
    });
  });
})();
